import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { BodyShopComponent } from './bodyshop.component';
import { BodyShopRoutes } from './bodyshop.routes';

@NgModule({
  declarations: [
      BodyShopComponent
  ],
  imports: [
    SharedModule,
    BodyShopRoutes
  ],
  exports: [
    BodyShopComponent
  ]
})

export class BodyShopModule { }
